import {useGetAndSet} from "./useGetAndSet";
import {createSetTrackingOptionDataAction} from "../actions/dataActions";

export const useTrackingOptionsData = (params, dataFresh) => {
    return useGetAndSet("trackingoption", params, createSetTrackingOptionDataAction, dataFresh);
}